import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-token';
import { HTTP_GO } from '../../core/http/http-common-go';
import { service_Go } from '../../service';
import { API_G_STREAMER } from '../../service';
import store from './common-data';
import common from '../../helpers/common';
import { service } from '../../service';
import i18n from '../../i18n/index';
import axios from "axios"

var moment = require('moment');

const state = {
  dataShareLink: '',
  all: [],
  selected: {},
  currentPage: 0,
  nbPerPage: 20,
  contributors: [],
  channels: [],
  types:[],
  live: {},
  totalLive: 0,
  periodLives: [],
  currentLang: 'fr',
  loading: false,
  exportLink: {},
  detailLive: {},
  users: {},
  webtvUsers: [],
  webtvGroups: [],
  groupUsers: {},
  screenShare: {},
  urlDownloadFile: {},
  objectDiffusion: {},
  linkArchivedVideo: {},
  isArchivedLive: false,
  liveId: '',
  allTemplates: [],
  listGroup: [],
  listMail: [],
  responseDelete: {},
  externalHls: false,
  linkHls: '',
  liveSkins:[],
  participants:[]
};

const mutations = {
  selectLive(state, data) {

    let tags = data.live.tags && data.live.tags.length > 0 ? data.live.tags.split(' ').filter(t => t.length > 0) : data.live.tags;
    if (tags == '') tags = [];


    const mappedData = {
      startDate: moment(data.live.dateStart).format(),
      startTime: moment(data.live.dateStart).format('HH:mm'),
      endTime: moment(data.live.dateEnd).format('HH:mm'),
      tags: tags,
      survey: data.live.survey ? data.live.survey.id : null,
      diffusion: data.live.isPearl ? 'isPearl' : data.live.screenShare ? 'screenShare' : data.live.webinar ? "webinar" : "externalHls",
      linkHls: data.live.linkHls,
      screenType: data.live.screenType ? data.live.screenType : 'pip',
      contributors: data.live.contributors && data.live.contributors.length > 0 ?
        data.live.contributors.map(c => ({
          id: c.id,
          name: c.firstName + ' ' + c.lastName,
        })) : data.live.contributors,
      editor: {
        dataAbout: data.live.editor !== undefined ? data.live.editor.dataAbout : null,
      },
      allIntervenants: data.live.allIntervenants && data.live.allIntervenants.length > 0 ? data.live.allIntervenants : [],
      contact: {
        address: data.live.contact !== undefined ? data.live.contact.address : null,
        phone: data.live.contact !== undefined ? data.live.contact.phone : null,
        email: data.live.contact !== undefined ? data.live.contact.email : null,
      },
      slides: data.slides && data.slides.length > 0 ? data.slides : [],
      chapters: data.chapters && data.chapters.length > 0 ? data.chapters : [],
      emails: data.live.emails && data.live.emails.length > 0 ? data.live.emails : [],
      groupEmails: data.live.groupEmails && data.live.groupEmails.length > 0 ? data.live.groupEmails : [],
      rules: data.live.rules && data.live.rules.length > 0 ? data.live.rules : [{
        nbDays: 1,
        beforeHour: moment().format('HH:mm'),
      }],


      themes: data.live.themes,
      conf: { ...data.live.conf, video: data.live.conf.video ? data.live.conf.video.id : null },
      videoBeforeLive: data.live.conf.video ? data.live.conf.video : null,
      files: common.buildIcons(data.files),
      questions: data.questions && data.questions.length > 0 ?
        data.questions.map(q => {
          if (!q.choices) {
            q.choices = [];
            q.nsp = +q.nsp;
          }
          return q;
        }) : data.questions,

    };

    if (mappedData.videoBeforeLive && !mappedData.videoBeforeLive.logo) {
      mappedData.videoBeforeLive.logo =
        'data:image/png;base64,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';
    }

    state.selected = {
      ...data.live,     // raw API live
      ...mappedData,    // cleaned + computed fields
    };
    },
  pushLives(state, lives) {
    //state.all = state.all.concat(lives);
    state.all = lives.map((live) => {

      return {
        ...live,
        title: live.title.length > 30 ? live.title.substring(0, 30) + '...' : live.title,
      };
    });
  },
  incrementPage(state, number) {
    state.currentPage = number;
  },
  setHlsValue(state, value) {
    state.linkHls = value
  },
  setEndReached(state, endReached) {
    state.endReached = endReached;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setContributors(state, contributors) {
    state.contributors = contributors;
  },
  setChannels(state, channels) {
    state.channels = channels;
  },
  setTypes(state, types) {
    state.types = types;
  },
  setLiveById(state, data) {
    state.live = data.live;
  },
  UpdateTotalLive(state, recordTotal) {
    state.totalLive = recordTotal;
  },
  setPeriodLives(state, data) {
    state.periodLives = data || [];
  },
  setCurrentLang(state, data) {
    state.currentLang = data || {};
  },
  setInfoDetailLive(state, data) {
    state.detailLive = data;
  },
  setLinkExportLives(state, data) {

    if (data['permalien']) {
      if (data['permalien'][0]) {
        data['permalien'][0] = data['permalien'][0].replace('/fr', '/' + i18n.locale).replace('/en', `/${i18n.locale}`)
      }
      if (data["permalien"][1]) {
        data['permalien'][1] = data['permalien'][1].replace('/fr', '/' + i18n.locale).replace('/en', `/${i18n.locale}`)
      }
    }
    if (data['link_moderator']) {
      data['link_moderator'] = data['link_moderator'].replace('/fr', '/' + i18n.locale).replace('/en', `/${i18n.locale}`)
    }
    if (data['link_journalist']) {
      data['link_journalist'] = data['link_journalist'].replace('/fr', '/' + i18n.locale).replace('/en', `/${i18n.locale}`)
    }

    state.exportLink = data;
  },

  setWebtvUsers(state, data) {
    state.webtvUsers = data;
  },

  setWebtvGroups(state, data) {
    state.webtvGroups = data
  },

  setSubscriptionUser(state, data) {
    state.users = data;
  },
  setSubscriptionGroupUsers(state, data) {
    state.groupUsers = data;
  },
  setScreenShare(state, data) {
    state.screenShare = data;
  },
  setUrlDownloadFile(state, data) {
    state.urlDownloadFile = data;
  },
  setDiffusionObject(state, obj) {
    state.objectDiffusion = obj;
  },
  removeLiveById(state, id) {
    state.all = state.all.filter(l => l.id !== id);
  },
  setLinkArchivedVideo(state, link) {
    state.linkArchivedVideo = link;
  },
  setArchivedLive(state, val) {
    state.isArchivedLive = val;
  },
  setDataShareLink(state, data) {
    state.dataShareLink = data;
  },
  setLiveId(state, id) {
    state.liveId = id;
  },
  setAllSkinTemplates(state, templates) {
    state.allTemplates = templates;
  },
  addToListGroup(state, group) {
    state.listGroup.push(group);

  },
  addOneMailIntoGroup(state, data) {
    state.listGroup = state.listGroup.map((group, i) => {
      if (group.id === data.id) {
        group.users.push({ email: data.email });
      }
      return group;
    });
  },
  setListMail(state, val) {
    state.listMail = val;
  },
  addIntoListMail(state, email) {
    const find = state.listMail.find((item) => item === email);

    if (!find) {
      state.listMail.push(email);
    }
  },
  deleteOneMailIntoGroup(state, data) {
    state.listGroup = state.listGroup.map((group, i) => {
      if (group.id === data.id) {
        group.users = group.users.filter(mail => mail.email !== data.email);
      }
      return group;
    });
  },
  deleteOneMailIntoListMail(state, data) {
    state.listMail = state.listMail.filter((item) => item !== data);
  },
  deleteGroupMailFromListMail(state, id) {
    let group = state.listGroup.find(item => item.id === id);

    group.users.map((g) => {
      state.listMail = state.listMail.filter((item) => item !== g.email);

    });
  },
  RESPONSE_DELETE(state, data) {
    state.responseDelete = data
  },
  setLiveSkins(state, skins) {
    state.liveSkins = skins;
  },
};

const actions = {
  addOneMailIntoGroup: ({ state, commit }, data) =>
    commit('addOneMailIntoGroup', data),
  deleteOneMailIntoGroup: ({ state, commit }, data) =>
    commit('deleteOneMailIntoGroup', data),
  addIntoListMail: ({ state, commit }, data) =>
    commit('addIntoListMail', data),

  deleteOneMailIntoListMail: ({ state, commit }, data) =>
    commit('deleteOneMailIntoListMail', data),
  deleteGroupMailFromListMail: ({ state, commit }, data) =>
    commit('deleteGroupMailFromListMail', data),

  setListMail: ({ state, commit }, data) =>
    commit('setListMail', data),
  setHlsLinkValue: ({ state, commit }, data) => commit('setHlsValue', data),

  async addIntoListGroup({ commit }, id) {
    let self = this;
    const url = Routing.generate('api_subscription_user_get_users_by_group', { id: id });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url, { id: id })
        .then(function (response) {
          resolve(response);

        });
    });
    let group = { id: id, users: JSON.parse(JSON.stringify(data.data.users)) };
    commit('addToListGroup', group);

  },
  async restartDiffusionLive({ commit }, idLive) {
    let self = this;
    const url = Routing.generate('api_post_live_revive', { id: idLive });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .post(url, { id: idLive })
        .then(function (response) {
          resolve(response);
          if (response.data.code === 200 || response.status === 200) {
            eventHub.$emit("restartLive", { value: true, count: 0 })
          }
        });
    });
  },


  setDiffusionObject({ commit }, obj) {
    commit('setDiffusionObject', obj);
  },
  async paginate({ commit }, obj) {
    commit('setLoading', true);
    const { idUser } = store.state;
    const payload = {
      draw: obj.params.currentPage,
      length: obj.params.length,
      start: obj.params.start,
      'order[0][dir]': obj.params.order,
      'order[0][column]': obj.numColumn,
      ['columns[' + obj.numColumn + '][orderable]']: obj.params.orderable,
      idContributor: obj.params.idContributor,
      period: obj.params.period,
      startDate: obj.params.startDate,
      searchWord: obj.params.searchWord,
    };
    if (idUser) {
      payload.idUser = idUser;
    }
    const url = Routing.generate('api_dtable_list_dtable_lives_' + obj.type, payload);
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          resolve(response);
        });
    });
    commit('incrementPage', obj.params.currentPage);
    commit('UpdateTotalLive', data.recordsFiltered);
    commit('pushLives', data.data);
    commit('setEndReached', true);
    commit('setLoading', false);
  },
  async getLiveById({ commit }, id) {
    const url = Routing.generate('api_get_lives_live_detail', { id });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          resolve(response);
        });
    });
    commit('selectLive', data.data);
    commit('setLiveById', data.data);
    return data;
  },
  async fetchContributors({ commit }) {
    const url = Routing.generate('api_media_get_contributors');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          resolve(response);
        });
    });
    commit('setContributors', data.contributors);
  },
  async createLive({ state }, form) {
    const url = `${window.process.env.API_HOST_LIVE}/live/add`;
    try {
      // ----------------------------
      // 1) Build FormData payload
      // ----------------------------
      const fd = new FormData();

      // 👉 add thumbnail file if exists
      if (form.empLivesForm.thumbnail && form.empLivesForm.thumbnail instanceof File) {
        fd.append("thumbnail", form.empLivesForm.thumbnail);
      }
  
      // ----------------------------
      // 2) Build JSON for "data" field
      // ----------------------------
      const { sourceType,sourceTypeId, ...Data } = form.empLivesForm;
      const dataPayload = {
        ...Data, // clone all fields dynamically 
        ...(['empreinte','cnam','gers'].includes(window.process.env.CLIENT_NAME)
    ? { sourceTypeId: form.empLivesForm.isPearl ? 3 : (form.empLivesForm.sourceTypeId || 1) }
    : {}),       
        isCdn: form.empLivesForm.isCdn == "1", // fix type conversion
        active: form.empLivesForm.active ? 1 : 0,
        thumbnail: "",            // the API wants an empty string here
        conf: form.empLivesForm.conf || null,
        types: form.empLivesForm.types || [],
        chapters: form.empLivesForm.chapters || [],
        questions: form.empLivesForm.questions || [],
        slides: form.empLivesForm.slides || [],
        themes: form.empLivesForm.themes || [],
        countries: form.empLivesForm.countries && form.empLivesForm.countries.length ? form.empLivesForm.countries.map(item => item.id) : [],
        languages: form.empLivesForm.languages && form.empLivesForm.languages.length ? form.empLivesForm.languages.map(item => item.label) : [],
        status:-1,
        screenShare:form.empLivesForm.screen_share || false,
        contributors:form.empLivesForm.contributorID

      };
  
      // 👉 "data" must be a STRING in FormData
      fd.append("data", JSON.stringify(dataPayload));
  
      // ----------------------------
      // 3) POST multipart form-data
      // ----------------------------
      const response = await axios.post(url, fd, {
        headers: {
          "Authorization": `${window.ApiToken}`,
          "Content-Type": "multipart/form-data"
        }
      });
  
      // ----------------------------
      // 4) Send invitations
      // ----------------------------
      let emailsPayload = [];
  
      // Moderators
      if (form.empLivesForm.contributors && form.empLivesForm.contributors.length>0) {
        emailsPayload.push(
          ...form.empLivesForm.contributors.map(m => ({
            email: m.email,
            nom: m.lastName,
            prenom: m.firstName,
            role: "contributor",
          }))
        );
      }

      if (form.moderators && form.moderators.length>0) {
        emailsPayload.push(
          ...form.moderators.map(m => ({
            email: m.email,
            nom: m.lastName,
            prenom: m.firstName,
            role: "moderator",
          }))
        );
      }
    
      // Contributors (IDs → objects)
      if (form.empLivesForm.participants && form.empLivesForm.participants.length>0) {
     
        emailsPayload.push(
          ...form.empLivesForm.participants.map(c => {
            // 🔹 Custom contributor (typed email)
            if (c.isCustom) {
              return {
                email: c.email,
                nom: '',
                prenom: '',
                role: 'participant'
              };
            }
      
            // 🔹 Existing user (from webtvUsers)
            const user = state.webtvUsers.find(u => u.email === c.email);
      
            if (!user) return null;
      
            return {
              email: user.email,
              nom: user.lastName,
              prenom: user.firstName,
              role: 'participant'
            };
          }).filter(Boolean) // remove nulls safely
        );
            }
    
      if (!emailsPayload.length) {
        return response.data;
      }
    
      const payload = {
        emails: emailsPayload,
        groups: [],
        live_description: form.empLivesForm.description,
        live_id: response.data.Lives.id,
      };
    
      await axios.post(
        `${window.process.env.API_HOST_LIVE}/live/send-live-invitation`,
        payload,
        { headers: { Authorization: `${window.ApiToken}` } }
      );

  
      return response.data;
  
    } catch (e) {
      console.error("ERROR createLive", e);
      throw e;
    }
  }
,  
 async updateLive({ state }, form) {
  const url = `${window.process.env.API_HOST_LIVE}/live/edit/${form.id}`;
  
  try {
    // ----------------------------
    // 1) Build FormData payload
    // ----------------------------
    const fd = new FormData();
    // 👉 Add thumbnail file (if updated)
     // 👉 add thumbnail file if exists
     if (form.empLivesForm.thumbnail && form.empLivesForm.thumbnail instanceof File) {
      fd.append("thumbnail", form.empLivesForm.thumbnail);
    }
    const { sourceType,sourceTypeId,...DataForm } = form.empLivesForm;
    // ----------------------------
    // 2) Build JSON payload (same as create)
    // ----------------------------
    const { files, ...empLivesFormWithoutFiles } = form.empLivesForm || {};
    const dataPayload = {
      ...DataForm,
      id: form.id,
      ...(['empreinte','cnam','gers'].includes(window.process.env.CLIENT_NAME)
    ? { sourceTypeId: form.empLivesForm.isPearl ? 3 : (form.empLivesForm.sourceTypeId || 1) }
    : {}),                            // required for edit
      isCdn: form.empLivesForm.isCdn == "1",
      active: form.empLivesForm.active ? 1 : 0,
      thumbnail: "",
      conf: form.empLivesForm.conf || null,
      types: form.empLivesForm.types || [],
      chapters: form.empLivesForm.chapters || [],
      questions: form.empLivesForm.questions || [],
      slides: form.empLivesForm.slides || [],
      themes: form.empLivesForm.themes || [],
      countries: form.empLivesForm.countries && form.empLivesForm.countries.length
        ? form.empLivesForm.countries.map(item => item.id)
        : [],
      languages: form.empLivesForm.languages && form.empLivesForm.languages.length
        ? form.empLivesForm.languages.map(item => item.label)
        : [],
      screenShare:form.empLivesForm.screen_share  || false,
      contributors:form.empLivesForm.contributorID
    };
    // 👉 Append as string
    fd.append("data", JSON.stringify(dataPayload));

    // ----------------------------
    // 3) POST multipart form-data
    // ----------------------------
    const response = await axios.patch(url, fd, {
      headers: {
        "Authorization": `${window.ApiToken}`,
        "Content-Type": "multipart/form-data"
      }
    });

    // ----------------------------
    // 4) Send invitations
    // ----------------------------
    let emailsPayload = [];
      // WE SEND EMPTY ARRAY IN EDIT TO CLEAR BASE
    // Moderators
    if (form.empLivesForm.contributors && form.empLivesForm.contributors.length>0) {
      emailsPayload.push(
        ...form.empLivesForm.contributors.map(m => ({
          email: m.email,
          nom: m.lastName,
          prenom: m.firstName,
          role: "contributor",
        }))
      );
    }

    if (form.moderators && form.moderators.length>0) {
      emailsPayload.push(
        ...form.moderators.map(m => ({
          email: m.email,
          nom: m.lastName,
          prenom: m.firstName,
          role: "moderator",
        }))
      );
    }
  
    // Contributors (IDs → objects)
    if (form.empLivesForm.participants && form.empLivesForm.participants.length>0) {
      emailsPayload.push(
        ...form.empLivesForm.participants.map(c => {
          // 🔹 Custom contributor (typed email)
          if (c.isCustom) {
            return {
              email: c.email,
              nom: '',
              prenom: '',
              role: 'participant'
            };
          }
    
          // 🔹 Existing user (from webtvUsers)
          const user = state.webtvUsers.find(u => u.email === c.email);
    
          if (!user) return null;
    
          return {
            email: user.email,
            nom: user.lastName,
            prenom: user.firstName,
            role: 'participant'
          };
        }).filter(Boolean) // remove nulls safely
      );
              }
  
    // if (!emailsPayload.length) {
    //   return response.data;
    // }
  
    const payload = {
      emails: emailsPayload,
      groups: [],
      live_description: form.empLivesForm.description,
      live_id: form.id  ,
    };
  
    await axios.post(
      `${window.process.env.API_HOST_LIVE}/live/send-live-invitation`,
      payload,
      { headers: { Authorization: `${window.ApiToken}` } }
    );
    return response.data;

  } catch (error) {
    console.error("ERROR updateLive", error);
    throw error;
  }
},
  async setDisableLiveById({ state, commit }, id) {
    HTTP(window.ApiToken)
      .post(Routing.generate('api_post_disable_live', id), {
        id: id,
      })
      .then(function (response) {
      });
  },
  setStartLiveById({ state, commit }, data) {
    const changeActiveFormData = new FormData();
    const id = data.id;
    const streamName = data.streamName;
    changeActiveFormData.append('active', 1);
    HTTP(window.ApiToken).post("/live/change-active/" + id, changeActiveFormData).then(() => {
      const changeStatusFormData = new FormData();
      changeStatusFormData.append('status', 0);
      HTTP(window.ApiToken).post("/live/change-status/" + id, changeStatusFormData).then(() => {
        console.info("status changed to 0")
      }).catch((e) => {
        console.log("error while changing status", e)
      });
    }
    ).catch((e) => {
      console.log("error while starting live", e)
    });
    if(data.protocolType==="SRT"){
      // sending isDvr as false for now ..
      const isDvr = data.isDvr?data.isDvr:false;

      const startData = {
        id: streamName,
        stream: {
          name: streamName,
          variantNames: ["video_4000", "bypass_audio"]
        },
    interval: 900000,
    segmentationRule: "continuity"
      }
API_G_STREAMER.startRecordGStreamer(startData,isDvr).then((res)=>{
console.log('Starting record in progress',res)
}).catch((err)=>{
console.error("Error while Starting record",err)
})
}
  },
  async setStopLiveById({ state, commit }, data) {
    
    if (data.streamName) {
      const changeActiveFormData = new FormData();
      changeActiveFormData.append('active', 0);
      HTTP(window.ApiToken).post("/live/change-active/" + data.id, changeActiveFormData).then(() => {
        const changeStatusFormData = new FormData();
        changeStatusFormData.append('status', 1);
        HTTP(window.ApiToken).post("/live/change-status/" + data.id, changeStatusFormData).then(() => {
          console.info("status changed to 1")
        }).catch((e) => {
          console.log("error while changing status", e)
        });
      }
      ).catch((e) => {
        console.log("error while ending live", e)
      });
      const liveObject = data.live;
      if(liveObject.protocolType==="SRT"){
                // sending isDvr as false for now ..
        const isDvr = liveObject.isDvr?liveObject.isDvr:false;
        API_G_STREAMER.stopRecordGStreamer({
          id: data.streamName,
                },isDvr).then((res)=>{
          console.log('Stopping record in progress',res)
          API_G_STREAMER.stopGStreamer({
            stream_name: data.streamName,
            client_name: window.process.env.CLIENT_NAME,
            bucket_name: window.process.env.CLIENT_NAME,
            piper_api: window.process.env.PIPER_ENDPOINT,
            live_api: "https:" + window.process.env.API_HOST_LIVE,
            is_auto:liveObject.isAuto?liveObject.isAuto:false,
            processor_guid:liveObject.processorGuid?liveObject.processorGuid:"",
            protocol_type:liveObject.protocolType?liveObject.protocolType:"",
            is_event:false
          })
        }).catch((err)=>{
          console.error("Error while stopping record",err)
        })
      }else{
        API_G_STREAMER.stopGStreamer({
          stream_name: data.streamName,
          client_name: window.process.env.CLIENT_NAME,
          bucket_name: window.process.env.CLIENT_NAME,
          piper_api: window.process.env.PIPER_ENDPOINT,
          live_api: "https:" + window.process.env.API_HOST_LIVE,
          is_auto:liveObject.isAuto?liveObject.isAuto:false,
          processor_guid:liveObject.processorGuid?liveObject.processorGuid:"",
          protocol_type:liveObject.protocolType?liveObject.protocolType:"",
          is_event:false
        })
      }
   
      var roomName = data.id + '-' + data.streamName;
      let objectPusher = {
        data: JSON.stringify({ date: new Date().getTime() }),
        prefixChannelName: 'room-join',
        event: 'end'
      }
    }
  },

  async setEnableLiveById({ state, commit }, data) {
    if (data.streamName) {
      var roomName = data.id + '-' + data.streamName;
      let objectPusher = {
        data: JSON.stringify({ date: new Date().getTime() }),
        prefixChannelName: 'streams',
        event: 'get'
      }

    }
  },
  async deleteMultiLive({ commit }, obj) {
    let list = obj.join(',');
    HTTP(window.ApiToken)
      .delete(Routing.generate('api_multi_delete_livess', { list: list }).replace(/%2C/g, ','))
      .then(function (response) {
      });
  },
  async deleteLiveById({ commit }, id) {
    HTTP(window.ApiToken)
      .delete(Routing.generate('api_delete_lives_live', { id: id }))
      .then(function (response) {
      });
  },
   exportQuestionsByLiveId({ commit }, id) {
      return axios.get(window.process.env.API_HOST_GLOBAL+"/live/questions/export/" + id, {
        headers: {
          "Content-Type" : "application/json",
          Authorization: window.ApiToken,
        },
        responseType: 'blob',
      });
  },
  async fetchAllSkinTemplates({ commit }) {
    let data = await new Promise((resolve, reject) => {
      let uid = 'cvJntHgPp0mzeWSd';
      service(uid)
        .api.templatesGetTemplatesList('')
        .then(function (response) {
          resolve(response);
          console.log('response', response);
        })
        .catch(failure => {
          console.log('failure', failure);
        });
    });
    commit('setAllSkinTemplates', data.templates);
  },
  async sendSendGridEmail({ commit }, obj) {
    const url = '/live/send-invitations';
    const { data } = await new Promise((resolve, reject) => {
      HTTP_GO(window.ApiToken)
        .post(url, obj)
        .then(function (response) {
          resolve(response);
        });
    });
    return data;
  },
  async restoreArchivedLive({ commit }, { id, action }) {

    const { data } = await new Promise(async (resolve, reject) => {
      await service_Go.restoreArchivedLive({ liveId: id, action })
        .then(response => {
          console.log('deleteMultipleLives', response);
          resolve(response)
          commit('RESPONSE_DELETE', { action: action, multi: false, error: false })
        })
        .catch(error => {
          console.log("deleteMultipleLives error", error)
          commit('RESPONSE_DELETE', { action: action, multi: false, error: true })
        })
    })
    return data
  },
  async restoreArchivedMultiLive({ commit }, list) {
    const { data } = await new Promise(async (resolve, reject) => {
      await service_Go.restoreArchivedMultiLive(list)
        .then(response => {
          console.log('restoreArchivedMultiLive', response);
          resolve(response)
          commit('RESPONSE_DELETE', { action: list.action, multi: false, error: false })
        })
        .catch(error => {
          console.log("restoreArchivedMultiLive error", error)
          commit('RESPONSE_DELETE', { action: list.action, multi: false, error: true })
        })
    })
    return data
  },
  async deleteMultipleLives({ commit }, list) {
    const { data } = await new Promise(async (resolve, reject) => {
      await service_Go.deleteMultiLive({ data: list })
        .then(response => {
          console.log('deleteMultipleLives', response);
          resolve(response)
          commit('RESPONSE_DELETE', { action: 'deleting', multi: true, error: false })
        })
        .catch(error => {
          console.log("deleteMultipleLives error", error)
          commit('RESPONSE_DELETE', { action: 'deleting', multi: true, error: true })
        })
    })
    return data
  },
  async deleteLiveByOne({ commit }, liveId) {
    const { data } = await new Promise(async (resolve, reject) => {
      await service_Go.deleteLive(liveId)
        .then(response => {
          console.log('deleteLiveByOne', response);
          resolve(response)
          commit('RESPONSE_DELETE', { action: 'deleting', multi: false, error: false })
        })
        .catch(error => {
          console.log("deleteLiveByOne error", error)
          commit('RESPONSE_DELETE', { action: 'deleting', multi: false, error: true })
        })
    })
    return data
  },
  async getAllLivesByPeriod({ commit }, period) {
    commit('setLoading', true);
    const url = Routing.generate('api_get_lives_by_period', period);
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken) 
      .get(url)
        .then(response => {
          if (response.data.lives) {
            Array.prototype.slice
              .call(
                // convert to array
                response.data.lives,
              )
              .map(function (eventEl) {
                let customColor = common.getMaterialColor();
                let currentDate = common.getDateLive(new Date());
                if (eventEl) {
                  let startDate = common.getDateLive(new Date(eventEl.start));
                  let endDate = common.getDateLive(new Date(eventEl.end));

                  if (startDate <= currentDate && endDate >= currentDate) {
                    eventEl.textColor = customColor[0]; ///green----->current
                    eventEl.status = 'Live';
                    eventEl.classType = 'badge-danger';

                  } else if (startDate > currentDate && endDate > currentDate) {
                    eventEl.textColor = customColor[1]; ///blue------>future
                    eventEl.status = 'Waiting';
                    eventEl.classType = 'badge-warning';
                  } else if (startDate < currentDate && endDate < currentDate) {
                    eventEl.textColor = customColor[2]; ///violet----->past
                    eventEl.status = 'Archive';
                    eventEl.classType = 'badge-secondary';
                  }
                  eventEl.borderColor = eventEl.textColor;
                  eventEl.backgroundColor = eventEl.textColor;
                }
              });

            resolve(response);
          }
        });
    });
    commit('setPeriodLives', data.lives);
  },
  async getInfosDetail({ commit }, id) {
    const url = Routing.generate('api_getInfosDetailLive', { id });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          resolve(response);
        });
    });
    commit('setInfoDetailLive', data);
    return data;
  },
  async getLinkExport({ commit }, id) {
    const url = Routing.generate('api_getlink_export', { id });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url + "?get_moderator=1")
        .then(response => {
          if (response.data) {
            resolve(response);
          }
        })
    });
    commit('setLinkExportLives', data);
    return data;
  },
  async getSubscriptionUserList({ commit }) {
    const url = Routing.generate('api_getSubscriptionUser_list');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          if (response.data) {
            resolve(response);
          }
        });
    });
    commit('setSubscriptionUser', data.data.users);
    return data;
  },

  async getWebtvUsersList({ commit }) {
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get("/dataTable/users?columns[0][orderable]=true&length=1000&idGroup=0&order[0][column]=0&order[0][dir]=asc&search[value]=&start=0")
        .then(response => {
          if (response.data) {
            resolve(response);
          }
        });
    });
    commit('setWebtvUsers', data.data);
    return data;
  },


  async getWebtvGroupsList({ commit }) {
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get("/dataTable/groups?columns[0][orderable]=true&length=1000&idGroup=0&order[0][column]=0&order[0][dir]=asc&search[value]=&start=0")
        .then(response => {
          if (response.data) {
            resolve(response);
          }
        });
    });
    commit('setWebtvGroups', data.data);
    return data;
  },


  async getSubscriptionGroupUsersList({ commit }) {
    const url = Routing.generate('api_subscription_group_get_groups');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          if (response.data) {
            resolve(response);
          }
        });
    });
    commit('setSubscriptionGroupUsers', data.data.groups);
    return data;
  },
  async setCurrentLang({ commit }, lang) {
    commit('setCurrentLang', lang);
  },
  async sendInvitationsMails({ state, commit }, obj) {
    const url = Routing.generate('api_send_invitations_mails');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .post(url, obj)
        .then(function (response) {
          resolve(response);
        });
    });
    return data;
  },
  async sendInvitationsGroupMails({ state, commit }, obj) {
    const url = Routing.generate('api_post_invitation_groups_mails');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .post(url, obj)
        .then(function (response) {
          resolve(response);
        });
    });
    return data;
  },
  async setScreenShare({ commit }, obj) {
    const url = Routing.generate('api_screen_share', { id: obj.id, screenType: obj.screenType });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          if (response.data) {
            resolve(response);
          }
        });
    });
    commit('setScreenShare', data);
    return data;
  },
  async getUrlDownloadFile({ commit }, id) {
    const url = Routing.generate('api_get_url_download_file', { id: id });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          if (response.data) {
            resolve(response);
          }
        });
    });
    commit('setUrlDownloadFile', data);
    return data;
  },
  setLives({ commit }, lives) {
    commit('pushLives', lives);
  },
  removeLiveById({ commit }, id) {
    commit('removeLiveById', id);
  },
  async getUrlLinkArchivedVideo({ commit }, id) {
    const url = Routing.generate('api_get_link_video_live', { id: id });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          console.log('response', response);
          if (response.data) {
            resolve(response.data);
            console.log('data', response.data);
            commit('setLinkArchivedVideo', response.data);
          }
        })
        .catch(error => {
          reject(error.response.data);
          console.log('data', error.response.data);
          commit('setLinkArchivedVideo', error.response.data);
        });
    });

    //return data;
  },
  isArchivedLive({ commit }, val) {
    commit('setArchivedLive', val);
  },
    async fetchLiveTypes({ commit }) {
    const url = Routing.generate('api_parameters_get_live_types');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          resolve(response);
        });
    });
    commit('setTypes', data.data);
  },

  async fetchChannels({ commit }) {
    const url = Routing.generate('api_parameters_get_channels_group_by_themes');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          resolve(response);
        });
    });
    commit('setChannels', data.channels);
  },

  async apiShareLink({ commit }, id) {
    try {
      commit('setLiveId', id);

    } catch (e) {
      console.log("ERROR:", e)
    }
  },
  async apiSendDataMail({ commit }, data) {
    const { reponse } = await service_Go.sendDataLinkShare(data);
    try {
      console.log('apisendDataMail', reponse);
    } catch (e) {
    }
  },
  async fetchLiveSkins({ commit }) {
    const url = Routing.generate('api_live_get_skins');
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(response => {
          resolve(response);
        });
    });
    commit('setLiveSkins', data.skins);
  },
};

const getters = {
  getSelected: state => state.selected,
  getLive: state => state.live,
  getContributors: state => state.contributors,
  getChannels: state => state.channels,
  getTypes: state => state.types,
  getAllLives: state => state.all,
  getTotalLive: state => state.totalLive,
  getLivesByPeriod: state => state.periodLives,
  getCurrentLang: state => state.currentLang,
  getIsLoading: state => state.loading,
  getLinkExportLives: state => state.exportLink,
  getInfoDetailLive: state => state.detailLive,
  getSubscriptionUser: state => state.users,
  getSubscriptionGroupUsers: state => state.groupUsers,
  getWebtvUsers: state => state.webtvUsers,
  getWebtvGroups: state => state.webtvGroups,
  getUrlDownloadFile: state => state.urlDownloadFile,
  getDiffusionObject: state => state.objectDiffusion,
  getLinkArchivedVideo: state => state.linkArchivedVideo,
  getArchivedLive: state => state.isArchivedLive,
  getDataShareLink: state => state.dataShareLink,
  getLiveId: state => state.liveId,
  getAllSkinTemplates: state => state.allTemplates,
  getlistGroup: state => state.listGroup,
  getlistMail: state => state.listMail,
  getGroupById: state => id => state.listGroup.find(item => item.id === id),
  isGroupExist: state => id => state.listGroup.some(g => g.id === id),
  getResponseDelete: state => state.responseDelete,
  getHlsValue: state => state.linkHls,
  getLiveSkins: state=>state.liveSkins

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/lives-data.js